
import React from 'react';

const Winner = ({ winnerName, onPlayAgain }) => {
  return (
    <div id="tm__winner" className="tm2">
      <div className="winner__name">{winnerName}</div>
      <div className="winner__text">wins the game!</div>
      <button className="btn btn-gold" onClick={onPlayAgain}>
        Play Again
      </button>
    </div>
  );
};

export default Winner;

